<script>
export default {
    template: " ",
    mounted() {
        window.Echo.private('elements.' + this.elementUUID)
            .listen('.measure.saved', (data) => { //TODO: DRY
                //console.log('websocket -> MEASURE SAVED fron Element: ' + data.measure, data);

                this.$store.commit('addMeasure', data.measure);
            });

        /*window.Echo.private('projects.' + this.projectUUID)
            .listen('.client-measure.saved', (data) => { //TODO: DRY
                console.log('websocket -> CLIENT MEASURE SAVED from Projects: ' + data.measure, data);

                this.$store.commit('addMeasure', data.measure);
            });*/

        console.log('PRIVATE: projects.' + this.projectUUID);
        console.log('PRIVATE: elements.' + this.elementUUID);

    },
    data() {
        return {
            'projectUUID': this.getProjectUUID(),
            'elementUUID': this.getElementUUID()
        }
    },
    methods: {
        getProjectUUID() {
            //TODO: DRY y no estoy seguro si lo estamos usando aqui!
            let projectUUID = document.head.querySelector('meta[name="meta-projectUUID"]');

            if (projectUUID) {
                return projectUUID.content;
            }
            else {
                console.error('projectUUID meta not found.');
            }
        },
        getElementUUID() {
            //TODO: DRY
            let elementUUID = document.head.querySelector('meta[name="meta-elementUUID"]');

            if (elementUUID) {
                return elementUUID.content;
            }
            else {
                console.error('elementUUID meta not found.');
            }
        }
    }
}
</script>
